export default __webpack_public_path__ + "static/scam-latitude-protect-alert-4-d56ece3d25f99c795c0a376631938f72.webp";